// extracted by mini-css-extract-plugin
module.exports = {"eventLog":"ErrorLog_eventLog__3CqmI","innerCard":"ErrorLog_innerCard__13HqC"};